var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventmanagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1693 14.1003H13.8359V27.4337H27.1693V14.1003Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.83594 37.4337C11.5859 37.4337 13.8359 35.1837 13.8359 32.4337V27.4337H8.83594C6.08594 27.4337 3.83594 29.6837 3.83594 32.4337C3.83594 35.1837 6.08594 37.4337 8.83594 37.4337ZM8.83594 14.1003H13.8359V9.10034C13.8359 6.35034 11.5859 4.10034 8.83594 4.10034C6.08594 4.10034 3.83594 6.35034 3.83594 9.10034C3.83594 11.8503 6.08594 14.1003 8.83594 14.1003ZM27.1693 14.1003H32.1693C34.9193 14.1003 37.1693 11.8503 37.1693 9.10034C37.1693 6.35034 34.9193 4.10034 32.1693 4.10034C29.4193 4.10034 27.1693 6.35034 27.1693 9.10034V14.1003ZM32.1693 37.4337C34.9193 37.4337 37.1693 35.1837 37.1693 32.4337C37.1693 29.6837 34.9193 27.4337 32.1693 27.4337H27.1693V32.4337C27.1693 35.1837 29.4193 37.4337 32.1693 37.4337Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventmanagement);
export default __webpack_public_path__ + "static/media/eventmanagement.119eb0fdf98af8273448622bac03d5b7.svg";
export { ForwardRef as ReactComponent };